import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "desktop-confirm-section" }
const _hoisted_2 = { class: "desktop-confirm-header" }
const _hoisted_3 = { class: "desktop-confirm-title" }
const _hoisted_4 = {
  key: 0,
  class: "desktop-no-entries"
}
const _hoisted_5 = {
  key: 1,
  class: "desktop-lines-section"
}
const _hoisted_6 = { class: "desktop-lines-header" }
const _hoisted_7 = { class: "desktop-lines-list" }
const _hoisted_8 = { class: "desktop-line-content" }
const _hoisted_9 = { class: "desktop-line-numbers" }
const _hoisted_10 = { class: "desktop-line-balls" }
const _hoisted_11 = {
  key: 0,
  class: "desktop-line-bonus"
}
const _hoisted_12 = { class: "desktop-line-bonus-ball" }
const _hoisted_13 = { class: "desktop-line-odds" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["disabled"]


import { formatOdds } from '../../utils/currency';


const __default__ = {
  name: "DesktopConfirmSection",
};

interface Line {
  numbers: number[];
  bonus?: number;
  numBets: number;
  picks: number;
  market?: {
    marketGroup: {
      group_id: number;
      name: string;
      slug: string;
      group_ordering: number;
      has_bonus_ball: boolean;
      markets: Array<{
        market_id: number;
        market_name: string;
        market_slug: string;
        market_description: string;
        market_additional_info: string;
        market_ordering: number;
        market_active: boolean;
        outcomes: Array<{
          outcome_id: number;
          text: string;
          select_numbers: boolean;
          pick: number;
          slug: string;
          odds: string;
          true_odds: string;
          probability: string;
          specifier: string | null;
          market_outcomes_id: number;
        }>;
      }>;
      ballset: {
        rules: Array<{
          id: number;
          name: string;
          balls_min: number;
          balls_max: number;
          picks_min: number;
          picks_max: number;
          has_bonus: number;
          max_resulted: number;
          type: string;
        }>;
      };
    };
    market: {
      market_id: number;
      market_name: string;
      market_slug: string;
      market_description: string;
      market_additional_info: string;
      market_ordering: number;
      market_active: boolean;
      outcomes: Array<{
        outcome_id: number;
        text: string;
        select_numbers: boolean;
        pick: number;
        slug: string;
        odds: string;
        true_odds: string;
        probability: string;
        specifier: string | null;
        market_outcomes_id: number;
      }>;
    };
    label: string;
    odds: number;
    select_numbers: boolean;
    balls: number;
    outcome_id: string;
  };
}

interface Props {
  lines: Line[];
  currentGameSlug?: string;
  selectedRelatedGames?: string[];
  isProcessing?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    lines: {},
    currentGameSlug: {},
    selectedRelatedGames: { default: () => [] },
    isProcessing: { type: Boolean, default: false }
  },
  emits: ["clear-all", "remove-line", "add-to-betslip", "update:selectedRelatedGames"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const getLineOdds = (line: Line): number | null => {
  if (line.market) {
    return line.market.odds;
  }
  return null;
};

const formatLineOdds = (line: Line): string => {
  const odds = getLineOdds(line);
  return odds ? formatOdds(odds) : '1.00';
};

const removeLine = (index: number) => {
  emit('remove-line', index);
};

const clearAll = () => {
  emit('clear-all');
};

const addToBetslip = () => {
  emit('add-to-betslip', props.lines);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, "3. " + _toDisplayString(_ctx.$t('detail.confirmEntries')), 1)
    ]),
    (_ctx.lines.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('detail.noEntriesYet')), 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('detail.yourEntries')) + " (" + _toDisplayString(_ctx.lines.length) + ")", 1),
            _createElementVNode("button", {
              class: "desktop-clear-btn",
              onClick: clearAll
            }, _toDisplayString(_ctx.$t('common.clearAll')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lines, (line, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "desktop-line-item"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(line.numbers, (number) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: number,
                          class: "desktop-line-ball"
                        }, _toDisplayString(number), 1))
                      }), 128)),
                      (line.bonus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "desktop-line-bonus-separator" }, "+", -1)),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(line.bonus), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(formatLineOdds(line)), 1)
                ]),
                _createElementVNode("button", {
                  class: "desktop-remove-line-btn",
                  onClick: ($event: any) => (removeLine(index))
                }, " × ", 8, _hoisted_14)
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            class: "desktop-add-to-betslip-btn",
            onClick: addToBetslip,
            disabled: _ctx.lines.length === 0 || _ctx.isProcessing
          }, _toDisplayString(_ctx.$t('detail.addToBetslip')), 9, _hoisted_15)
        ]))
  ]))
}
}

})